import React, { useRef, useState, useEffect, useMemo } from 'react';
import { motion, useViewportScroll, useTransform, useSpring } from "framer-motion";
import { Link } from 'gatsby';
import InView from 'react-intersection-observer';
import HeaderAnim from '../common/utils/animations/textRevealAnimation';
import Parallax from '../common/utils/animations/parallax';
import { directions } from '../common/utils/animations/animationConstants';
import LazyLoad from 'react-lazyload';

export default function HomeProductBanner(props) {
  const { classes, banner, title, header, content } = props.data;
  const ref = [useRef(), useRef()];
  const [isVisible, setIsVisible] = useState(false);
  const handleChange = (inView) => {
    setIsVisible(inView);
  };

  return (
    <InView onChange={handleChange} threshold={[0.3]}>
      <div className={"home-product-banner-section section-gap " + classes}>
        <div className="row d-flex flex-wrap">
          <div ref={ref[0]} className="col home-product-banner-image">
            <Parallax classes="home-product-banner-image-inner" id="home-product-banner-image-inner" direction={directions.TTB} triggers={[1.2, 0.2]} length={250}>
              <div className="home-product-banner-layer0">
                <LazyLoad>
                  <img src={banner} title="digital product development HT" alt="digital product development services" />
                </LazyLoad>
              </div>
            </Parallax>
          </div>
          <div ref={ref[1]} className="col home-product-banner-content d-flex align-v-center justify-center">
            <div className="banner-content">
              <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
              <h2 className="h3">{header}</h2>
              <p >{content}</p>
              <Parallax id="banner-button" opacity={true} length={50} triggers={[1.1, 0.9]} direction={directions.RTL}>
                <Link to="/work/harris-teeter-online-grocery-shopping/" className="button right-arrow">View Case Study</Link>
              </Parallax>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}
